import { css } from "@emotion/css"

import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import estimateField from "../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"

const マウントデータの支給 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { provisionOfMountData: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="マウントデータの支給" helpURL={HELP_LINKS["マウントデータの支給"]}>
      <div className={style}>
        <RadioGroup
          name={estimateField.provisionOfMountData.key}
          selectedValue={values.provisionOfMountData}
          onChange={handlers.radio}
        >
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT.マウントデータの支給.あり.value}>あり</Radio>
            <Radio value={ESTIMATE_CONSTANT.マウントデータの支給.なし.value}>なし</Radio>
          </OneClickFieldStack>
        </RadioGroup>
        <OneClickFieldMessages error={errors?.provisionOfMountData} />
      </div>
    </OneClickField>
  )
}

export default マウントデータの支給

const style = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  > p:first-child {
    padding-bottom: 12px;
  }
`
